module.exports = __webpack_public_path__ + "resources/img/[NHNCloud]_Opengraph.08f74e511f3f88da9d942bc91e8cc32a.png";